import { render, staticRenderFns } from "./block-related.vue?vue&type=template&id=639ad354&"
import script from "./block-related.vue?vue&type=script&lang=js&"
export * from "./block-related.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports